//@flow
import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { isFeatureEnabled, sendTrackingEvent, trial_addon_event, voice_channel_selected_event } from 'h-commons';
import { CHANNEL_TITLE } from '../../channelAdmin/constants/voiceAPI.const';
import pick from 'lodash/pick';
import get from 'lodash/get';
import { AI_SUGGESTIONS, AI_SUGGESTIONS_GS_EVENTS } from '../constants';

class SessionedLink extends Component<Props, State> {
    
    constructor(props: Props) {
        super(props);
        this.state = {
            sessionedPath: null,
            userSession: null,
            original: null
        }
    }
    
    componentWillMount() {
        this.syncSessionToPath()
    }

    componentDidMount(){
        if (this.state.userSession !== this.props.sessionId)
            this.syncSessionToPath();
    }
    
    componentDidUpdate() {
        if (this.state.userSession !== this.props.sessionId) {
            this.syncSessionToPath();
        }

        if (this.state.original !== this.props.to)
            this.syncSessionToPath();
    }

    syncSessionToPath(){
        this.setState((state, props) => {
            const { to, sessionId } = props;
            const parts = to.split('?');
            const searchParams = parts[1] ? `${parts[1]}&usersession=${sessionId||''}` : `?usersession=${sessionId||''}`;
            const pathname = parts[1] ? parts[0]: to;
            const sessionedPath = { pathname, search: searchParams };
            return { ...state, original: to, sessionedPath, userSession: sessionId };
        })
    }

    render(){
        const { to, type, children, key, ...rest } = this.props;
        const { sessionedPath } = this.state;
        if (type === 'NavLink') {
            const navLinkProps = ['activeClassName', 'activeStyle','className' ,'exact', 'strict', 'isActive', 'location', 'ariaCurrent', 'data-for', 'data-tip'];
            const props = pick(rest, navLinkProps);
            // console.log(rest, props);
            return <NavLink to={sessionedPath||to}  onClick={() => onLinkClick(this.props)} key={key} {...props}>{children}</NavLink>;
        } else {
            const linkProps = ['key', 'className', 'replace', 'innerRef', 'others', 'exact', 'data-for', 'data-tip'];
            const props = pick(rest, linkProps);
            return <Link to={sessionedPath||to} onClick={() => onLinkClick(this.props)} key={key} {...props}>{children}</Link>;
        }
    }
}

const onLinkClick = (props) => {
    if (typeof props.onItemClick === 'function') {
        props.onItemClick();
    }
    if (props.gainsightEvent) {
        const { eventName, eventProps = {} } = props.gainsightEvent ?? {};
        sendTrackingEvent(eventName, eventProps);
    }
    if(props.label === "Automations" && isFeatureEnabled(props.availableFeatures, "ftr-new-automations-v1")){
        sendTrackingEvent("openedHiverAutomations");
    } else if(props.label === "createAutomation"){
        sendTrackingEvent("clickedCreateAutomation");
    } else if(props.label === AI_SUGGESTIONS){
        sendTrackingEvent(AI_SUGGESTIONS_GS_EVENTS.AI_SUGGESTION_SECTION_CLICKED);
    } else if(props.label ==="trialAddon"){
        sendTrackingEvent(trial_addon_event,{
            'Feature name':props.feature,
            'SM ID':props.smId
        });
    } else if(props.channel === CHANNEL_TITLE.AIRCALL){
        sendTrackingEvent(voice_channel_selected_event);
    }
} 

type Props = {
    to: string,
    channel: string,
    type: string,
    sessionId: null | string,
    key: number | string,
    children: Any,
    activeClassName: string,
    className: string
}
type State = {
    sessionedPath: string | null | Object,
    userSession: string | null
}

const mapStateToProps  = ({ appModes: { userSession }, userDetails}) => {
    const availableFeatures = get(userDetails, 'availableFeatures', []);
    return {
        sessionId: userSession,
        availableFeatures
    }

};
export default connect(mapStateToProps)(SessionedLink);